import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatToolbarModule } from '@angular/material/toolbar';

import {
  DxButtonModule,
  DxButtonGroupModule,
  DxPopupModule,
  DxFormModule,
  DxTextBoxModule,
  DxDateBoxModule,
  DxLookupModule,
  DxMenuModule,
  DxListModule,
  DxSelectBoxModule,
  DxAutocompleteModule,
  DxTileViewModule,
  DxNumberBoxModule,
  DxLoadIndicatorModule,
  DxLoadPanelModule,
  DxMultiViewModule,
  DxDataGridModule,
  DxCheckBoxModule,
  DxSwitchModule,
  DxValidationSummaryModule,
  DxPopoverModule,
  DxFileUploaderModule,
  DxProgressBarModule,
  DxTagBoxModule,
  DxScrollViewModule,
  DxDropDownButtonModule,
} from 'devextreme-angular';
import { EmployeeProfileComponent } from './employee-profile/employee-profile.component';
import { ContentHolderComponent } from './content-holder/content-holder.component';
import { AutoLogoutWarningMsgBoxComponent } from './autoLogoutWarningMsgBox/autoLogoutWarningMsgBox.component';
import { AS365PipesModule } from '../pipes/pipes';
import { ClientFinderComponent } from './client-finder/client-finder.component';
import { ClientInfoPanelComponent } from './client-info-panel/client-info-panel.component';
import { AppointmentBookerComponent } from './aptbooker/appointment-booker.component';
import { AppointmentTimeComponent } from './appointment-time/appointment-time.component';
import { AppointmentSessionComponent } from './appointment-session/appointment-session.component';
import { AppointmentResourceComponent } from './appointment-resource/appointment-resource.component';
import { AppointmentMakeSaleComponent as AppointmentMakeSaleComponent } from './appointment-makesale/appointment-makesale.component';
import { AppointmentBookaptComponent } from './appointment-bookapt/appointment-bookapt.component';
import { SaleItemEditorComponent } from './sale-item-editor/sale-item-editor.component';
import { NotesViewerComponent } from './notes-viewer/notes-viewer.component';
import { ClientEditorComponent } from './client-editor/client-editor.component';
import { ClientCreditHistoryComponent } from './client-credit-history/client-credit-history.component';
import { DisclaimerComponent } from './disclaimer/disclaimer.component';
import { TerminalSelectionComponent } from './terminal-selection/terminal-selection.component';
import { OpenTillComponent } from './open-till/open-till.component';
import { CloseTillComponent } from './close-till/close-till.component';
import { CloseTillDiscrepancyComponent } from './close-till-discrepancy/close-till-discrepancy.component';
import { ClientDisclaimerHistoryComponent } from './client-disclaimer-history/client-disclaimer-history.component';
import { ClientProductHistoryComponent } from './client-product-history/client-product-history.component';
import { SearchTextBoxComponent } from './search-textbox/search-textbox.component';
import { DateSelectorComponent } from './date-selector/date-selector.component';
import { EmailReportComponent } from './email-report/email-report.component';
import { CreditsCalculatorComponent } from './credits-calculator/credits-calculator.component';
import { ClientPhotoComponent } from './client-photo/client-photo.component';
import { WebcamModule } from 'ngx-webcam';
import { ClientPhotoUploadComponent } from './client-photo-upload/client-photo-upload.component';
import { VoucherCodeComponent } from './voucher-code/voucher-code.component';
import { VoucherDetailsComponent } from './voucher-details/voucher-details.component';
import { VoucherTenderComponent } from './voucher-tender/voucher-tender.component';
import { VoucherInputComponent } from './voucher-input/voucher-input.component';
import { EditSessionDelaysComponent } from './edit-session-delays/edit-session-delays.component';
import { SalesTransactionListComponent } from './sales-transaction-list/sales-transaction-list.component';
import { ClientFutureAppointments } from './client-future-appointments/client-future-appointments.component';
import { AddProductComponent } from './add-product/add-product.component';
import { ClientScreeningQuestionsComponent } from './client-screening-questions/client-screening-questions.component';

@NgModule({
  declarations: [
    EmailReportComponent,
    EmployeeProfileComponent,
    ContentHolderComponent,
    AutoLogoutWarningMsgBoxComponent,
    ClientFinderComponent,
    ClientInfoPanelComponent,
    ClientEditorComponent,
    AppointmentBookerComponent,
    AppointmentTimeComponent,
    AppointmentSessionComponent,
    AppointmentResourceComponent,
    AppointmentMakeSaleComponent,
    AppointmentBookaptComponent,
    SaleItemEditorComponent,
    NotesViewerComponent,
    ClientCreditHistoryComponent,
    ClientProductHistoryComponent,
    ClientFutureAppointments,
    DisclaimerComponent,
    TerminalSelectionComponent,
    OpenTillComponent,
    CloseTillComponent,
    CloseTillDiscrepancyComponent,
    ClientDisclaimerHistoryComponent,
    SearchTextBoxComponent,
    DateSelectorComponent,
    CreditsCalculatorComponent,
    ClientPhotoComponent,
    ClientPhotoUploadComponent,
    VoucherCodeComponent,
    VoucherDetailsComponent,
    VoucherTenderComponent,
    VoucherInputComponent,
    EditSessionDelaysComponent,
    SalesTransactionListComponent,
    AddProductComponent,
    ClientScreeningQuestionsComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    MatMenuModule,
    MatToolbarModule,
    MatIconModule,
    DxButtonModule,
    DxButtonGroupModule,
    DxPopupModule,
    DxFormModule,
    DxTextBoxModule,
    DxDateBoxModule,
    DxLookupModule,
    DxMenuModule,
    DxListModule,
    DxSelectBoxModule,
    DxAutocompleteModule,
    DxTileViewModule,
    DxNumberBoxModule,
    DxLoadIndicatorModule,
    DxMultiViewModule,
    DxLoadPanelModule,
    DxPopoverModule,
    DxFormModule,
    DxFileUploaderModule,
    DxProgressBarModule,
    DxValidationSummaryModule,
    DxSwitchModule,
    DxCheckBoxModule,
    DxDataGridModule,
    DxScrollViewModule,
    DxTagBoxModule,
    DxDropDownButtonModule,
    AS365PipesModule,
    WebcamModule,
  ],
  exports: [
    EmailReportComponent,
    EmployeeProfileComponent,
    ContentHolderComponent,
    AutoLogoutWarningMsgBoxComponent,
    ClientFinderComponent,
    ClientInfoPanelComponent,
    ClientEditorComponent,
    AppointmentBookerComponent,
    AppointmentMakeSaleComponent,
    TerminalSelectionComponent,
    OpenTillComponent,
    CloseTillComponent,
    SearchTextBoxComponent,
    DateSelectorComponent,
    AppointmentResourceComponent,
    ClientPhotoComponent,
    VoucherDetailsComponent,
    VoucherCodeComponent,
    VoucherInputComponent,
    EditSessionDelaysComponent,
    SalesTransactionListComponent,
  ],
  providers: [
    // WidgetService,
  ],
})
export class ComponentsModule {}
